import { ReviewsInvitationService } from '@weave/schema-gen-ts/dist/schemas/reviews/invitation/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaReviewsInvitationV1Service = bindHTTP(ReviewsInvitationService);
